import React from 'react';

import { useEarningsInsightsFilter } from '~/hooks/use-earnings-insights-filter/useEarningsInsightsFilter';
import { parseEarningsInsights } from '~/hooks/use-earnings-insights-filter/utils';
import { useIsEarningsInsightsEnabled } from '~/hooks/use-is-earnings-insights-enabled/useIsEarningsInsightsEnabled';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { EarningsInsightIcon } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import { DateCell, DateCellProps } from './DateCell';
import * as S from './DateCellWithEarningsInsight.styles';

export const DateCellWithEarningsInsight = ({
  earningsId,
  ...rest
}: DateCellProps & { earningsId: string }) => {
  const isEarningsInsightsEnabled = useIsEarningsInsightsEnabled();
  const { params } = useQueryParams();
  const entityTag = params[queryKeys.assetOverviewAsset];

  const { data = [] } = useEarningsInsightsFilter({
    body: { earnings_ids: [earningsId] },
    isEnabled: isEarningsInsightsEnabled && !!earningsId,
  });
  const earningsInsight = parseEarningsInsights(data);

  return (
    <S.Root>
      <DateCell {...rest} />
      {!!earningsInsight && isEarningsInsightsEnabled && entityTag && (
        <EarningsInsightIcon
          entityTag={entityTag}
          size={28}
          earningsInsight={earningsInsight}
          source={POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW}
        />
      )}
    </S.Root>
  );
};
